import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from '../../utils/obj-utils';
import { formStyleConstants } from '../../utils/constants/form-style-constants';

function FieldHeader({
    fieldName,
    headerTitle,
    headerText,
    textClassName
}) {
    const fieldClassName = fieldName || formStyleConstants.fieldHeaderClassName;
    return (
        isEmpty(headerTitle) && isEmpty(headerText) ?
            null :
            <div className={`field-header ${fieldClassName.toLowerCase()}-field`}>
                <h2 className="title field-header-title">{headerTitle}</h2>
                <div className={`fs-14 field-header-text ${textClassName}`}>
                    {headerText}
                </div>
            </div >
    );
}

FieldHeader.propTypes = {
    fieldName: PropTypes.string,
    headerTitle: PropTypes.string,
    headerText: PropTypes.string,
    textClassName: PropTypes.string,
};

export default FieldHeader;
